module.exports = __webpack_public_path__ + "img/MX-B048045C-BS.4378b2ab.png";